export function Certificate({
  showAttemps = false,
  message,
  handleOnclick,
}) {
  const hasAction = Boolean(message?.buttonLabel);

  return (
    <div className="modern-certificate-card anim" style={{ "--delay": ".3s" }}>
      <div className="modern-certificate-icon">
        <i className={hasAction ? "fas fa-award" : "fas fa-lock"} />
      </div>

      <div className="modern-certificate-copy">
        <span className="modern-certificate-eyebrow">
          CERTIFICADO
        </span>

        <strong>
          {hasAction ? "Tu certificado está disponible" : "Certificado del curso"}
        </strong>

        <p>{message?.msg}</p>

        {showAttemps && message?.attempts && (
          <span className="modern-certificate-attempts">
            {message.attempts}
          </span>
        )}
      </div>

      <div className="modern-certificate-action">
        <button
          type="button"
          onClick={handleOnclick}
          className={`modern-certificate-button ${
            hasAction ? "" : "is-locked"
          }`}
        >
          {message?.buttonLabel || <i className="fas fa-lock" />}
        </button>

        <form id="payment-form" method="GET" />
      </div>
    </div>
  );
}
